const baseURL = import.meta.env.VITE_API_URL || "http://localhost:5001";

const request = async (url, options = {}) => {
  const fullUrl = `${baseURL}${url}`;

  // Get token from Zustand persist storage
  let token = null;
  try {
    const authStorage = localStorage.getItem("auth-storage");
    if (authStorage) {
      const parsedAuth = JSON.parse(authStorage);
      token = parsedAuth.state?.token;
    }
  } catch (e) {
    console.error("Error parsing auth storage:", e);
  }

  const fetchOptions = {
    ...options,
    headers: {
      ...(options.headers || {}),
      // Only set Content-Type to JSON if body is not FormData
      ...(options.method &&
      options.method !== "GET" &&
      !(options.body instanceof FormData)
        ? { "Content-Type": "application/json" }
        : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };

  const response = await fetch(fullUrl, fetchOptions);

  // Handle authentication errors
  if (response.status === 401 || response.status === 403) {
    // Clear auth data from Zustand persist storage
    localStorage.removeItem("auth-storage");

    // Redirect to login
    window.location.href = "/#/login";
    throw new Error("Authentication failed. Please login again.");
  }

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error ${response.status}: ${errorText}`);
  }

  return response.status !== 204 ? response.json() : null;
};

export const fetcher = {
  get: (url) => request(url),
  post: (url, body) =>
    request(url, {
      method: "POST",
      // Don't JSON.stringify if body is FormData
      body: body instanceof FormData ? body : JSON.stringify(body),
    }),
  put: (url, body) =>
    request(url, {
      method: "PUT",
      body: JSON.stringify(body),
    }),
  delete: (url) => request(url, { method: "DELETE" }),
};
